export enum ItemViewType {
  AssetPortal = 'AssetPortal',
  SiteEvent = 'SiteEvent'
}
